// @flow

import type { RouteContext } from '@ta/lithium.context';
import { getRouteFromPath } from '@ta/lithium.router';
import { NAVIGATE } from './route';
import type { Action as AllActions } from './state';

const emptyState = () => [
  {
    page: 'Unknown',
    params: {},
    path: '/Unknown',
    fragment: '',
  },
  { uid: '', navigate: () => {}, navigateToFragment: () => {} },
];

export default (state: RouteContext = emptyState(), action: AllActions): RouteContext => {
  switch (action.type) {
    case NAVIGATE: {
      const route =
        getRouteFromPath(action.builtUrl) ||
        // eslint-disable-next-line no-restricted-globals
        getRouteFromPath(window.location.pathname + window.location.search);
      return route ? [route, state[1]] : [emptyState()[0], state[1]];
    }
    default:
      return state;
  }
};
